import { NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE_CATEGORY_GROUPS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { DrillDownParamsOriginal, EntityOriginal, ListResponse } from './types'

import type { ReportEntityWithQuantity } from '../../drilldown/types'

type ProductGroupCategory = ReportEntityWithQuantity & {
  productId: number
  productName: string
  productGroupId: number
}

type ProductGroupCategoryResponse = ListResponse<ProductGroupCategory> & {
  category: EntityOriginal
  product: EntityOriginal
  group: EntityOriginal
}

const IS_NEW_BACKEND_API = true

export const getDrillDownProducts = async (params: DrillDownParamsOriginal) => {
  const query = new URLSearchParams({ ...params })

  const productResult = await get<ProductGroupCategoryResponse>(
    `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE_CATEGORY_GROUPS}?${query.toString()}`,
    IS_NEW_BACKEND_API
  )

  return {
    ...productResult,
    rows: productResult.rows.map(product => ({
      ...product,
      amount: Number(product.amount),
      salaryDeductionAmount: Number(product.salaryDeductionAmount),
    })),
  }
}
